import { render, staticRenderFns } from "./ClientProfileDisputeStatus.vue?vue&type=template&id=6a61d256&"
import script from "./ClientProfileDisputeStatus.vue?vue&type=script&lang=js&"
export * from "./ClientProfileDisputeStatus.vue?vue&type=script&lang=js&"
import style0 from "./ClientProfileDisputeStatus.vue?vue&type=style&index=0&id=6a61d256&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports